import { cn } from "@/shared/lib/utils";

/** The live line over an unpaid instrument: the panel listens for the payment, and says how long it holds. */
export function WaitingForPayment({
  label,
  trailing,
  warn = false,
}: {
  label: string;
  trailing?: string | null;
  warn?: boolean;
}) {
  return (
    <div
      role="status"
      className="flex flex-wrap items-center justify-between gap-x-3 gap-y-1 rounded-lg border border-border bg-muted/40 px-3 py-2"
    >
      <span className="flex items-center gap-2 text-sm text-foreground">
        <span className="relative flex size-2" aria-hidden="true">
          <span className="absolute inline-flex size-full animate-ping rounded-full bg-primary/60 motion-reduce:animate-none" />
          <span className="relative inline-flex size-2 rounded-full bg-primary" />
        </span>
        {label}
      </span>
      {trailing && (
        <span
          className={cn("font-mono text-xs tabular-nums", warn ? "text-warning" : "text-muted-foreground")}
        >
          {trailing}
        </span>
      )}
    </div>
  );
}
